<template>
    <div>
        <h1>{{ translation["STR_OVERVIEW"]}}</h1>

        <div class="start">
        <div class="boxes" v-if="tableData.length">
            <div class="box">
                <div class="counter">{{ totalTests }}</div>
                <div class="value">{{ translation["STR_TOTALTESTS"] }}<sup>1</sup></div>
            </div>

            <div class="box">
                <div class="counter">{{ positiveProbes }}</div>
                <div class="value">{{ translation["STR_POSITIVETESTS"] }}<sup>1</sup></div>
            </div>

        </div>
        <div class="appx">
        <div class="table">
            <h1>{{ translation["STR_LAST8TESTS"] }}</h1>
            <table width="100%">
                <thead>
                    <th width="240">{{ translation["STR_TESTDATE"] }}</th>
                    <th width="120">{{ translation["STR_TOTALTESTS"] }}</th>
                    <th width="120">{{ translation["STR_POSITIVETESTS"] }}</th>
                    <th width="200">{{ translation["STR_SHOW"] }}</th>
                </thead>
                <tr v-for="t in tableData">
                    <td>{{ t.time | humanTime }}</td>
                    <td align="center">{{ t.wells.filter(e => e.target !=="CY5").length }}<sup>2</sup></td>
                    <td align="center">{{ t.wells.filter(e => e.positive == true && e.target !=="CY5").length }} <sup>2</sup></td>
                    <td v-on:click="reRender(t)">{{ translation["STR_SHOW"] }}</td>
                </tr>
                <tr v-if="!tableData.length">
                    <td colspan="10">Für Ihren Mandanten liegen aktuell noch keine Tests vor.</td>
                </tr>
            </table><br/>
            <div style="font-size: 8pt">
            <sup>1</sup> {{ translation["STR_TEST_CLEAN1"] }}<br/>
            <sup>2</sup> {{ translation["STR_TEST_CLEAN2"] }}<br/>
            </div>
            </div>
            

        </div>
        <div class="boxes" style="padding-left: 130px;" v-if="tableData.length && this.QRCodeURL">
            <qr-code :text="QRCodeURL" quality="1" :size="200" color="#00005a"></qr-code>
        </div>

        </div>
        
    </div>
</template>
<script>

export default ({
    props: [ 'serial', 'token', 'customer', 'translation'],
    data() {
        return {
            data:[],
            QRCodeURL: false,
        }
    },
    filters: {
        humanTime(unix_timestamp) {
            var a = new Date(unix_timestamp);
            var year = a.getFullYear();
            var month = a.getMonth()+1;
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();

            if(min < 10) min="0"+min;
            if(hour < 10) hour="0"+hour;
            if(sec < 10) sec="0"+sec;
            if(date < 10) date="0"+date;


            var time = date + '.' + month + '.' + year + ' ' + hour + ':' + min + ':' + sec ;
            return time;
        }
    },
    computed: {
        tableData() {
            if(this.serial) {
                var tt = this.data.filter(d => d.test !== null && d.wells.length > 0).filter(e => e.serial == this.serial);
            } else {
                var tt = this.data.filter(d => d.test !== null && d.wells.length > 0)
            }
            var yy = [];
            var times = [];
            tt.forEach((i) => {
                times.push(i.time);
            })
            times = times.sort().reverse();
            times.forEach((t) => {
                yy.push(tt.find(e => e.time == t))
            })
            return yy.slice(0,8);
        },
        percentPositive() {
            return (this.positiveProbes*100/this.totalTests).toFixed(1)
        },
        totalTests() {
            var positives = 0;
            return this.data.length;
            this.data.forEach((ds) => {
                positives=positives+ds.wells.filter(e => e.target !=="CY5" && e.sample.substr(-3) !== "TPC" && e.sample.substr(-3) !== "NTC").length;
            })
            return positives;
        },
        positiveProbes() {
            var positives = 0;
            this.data.forEach((ds) => {
                positives=positives+ds.wells.filter(e => e.positive == true && e.target !=="CY5" && e.sample.substr(-3) !== "TPC" && e.sample.substr(-3) !== "NTC").length;
            })
            return positives;
        }
    },
    methods: {
        BuildURL() {
            return "https://pocadmin.procomcure.com/"+this.customer.id;
        },
        cleanNumbers(n) {
            return n;
        },
        reRender(test) {
            this.$router.push({
                name: 'rerender',
                params: {
                    data: test,
                    id: test.testid
                }
            })
        }
    },
    mounted() {
        this.axios.get("/api/v2/qrcode",  { headers: { 'Authorization': 'Barear '+this.token}})
        .then((r) => {
            this.QRCodeURL = "https://pcradmin.procomcure.com/?tk="+r.data.token;
        })
        this.axios.get("/api/checkout?serial="+this.serial,  { headers: { 'Authorization': 'Barear '+this.token}})
        .then((r) => {
            this.data = r.data;
        })
    }
})
</script>

<style >
table {
    border-collapse: collapse;
}
h1 {
    color: var(--primary-color);
}
table td {
    padding: 10px;
}


.start {
    width: 100%;
    display: flex;
    flex-direction: row;
}
.boxes {
    display: flex;
    flex-direction: column;
    width: 200px;
    margin-right: 30px !important;

}

.box {
    height: 180px;
    width: 200px;
    display: flex;
    margin-bottom: 15px;
    flex-direction: column;
    background-color: var(--primary-color);
    color: var(--secondary-color);
}
sup {
    padding-right: 10px;
}
.counter {
    font-size: 40pt;
    width: 100%;
    text-align: center;
    justify-content: center;
    align-content: center;
    vertical-align: center;
    margin: auto;
    height: 50px;
}
.value {
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
}
</style>

<style scoped>

tr:nth-child(odd) {
    background-color: rgba(240,240,240,0.9);
}

.info {
    background-color: skyblue;
    padding: 10px;
    margin-top: 15px;
}

.qrcode {
    width: 200px;
}
</style>